export default __webpack_public_path__ + "static/media/feminipsum-mob.f271b401.png";